<template>
    <div id="detail">
        <div class="smallContent miscContent">
            <div id="galleryContainer">
                <swiper-container id="swiperContainer" navigation-next-el=".mainImage" loop="true"
                    pagination-el="#pagination" pagination-type="fraction">
                    <swiper-slide v-for="image in product.images">
                        <img :src="image" class="mainImage" alt="" />
                    </swiper-slide>
                </swiper-container>
                <div id="paginationContainer">
                    <div v-show="product.images.length > 1" id="pagination"></div>
                </div>
            </div>

            <div id="textContainer">
                <div id="title" v-html="product.title"></div>
                <div id="price" v-html="formatPrice(product.price)"></div>
                <div v-if="product.options.length" id="options">
                    <div class="option" v-for="option in product.options" @click="selected = option; added = false"
                        :class="{ selected: option == selected }">
                        {{ option }}
                    </div>
                </div>

                <div v-if="product.options.length && selected == ''" id="select">
                    Select {{ product.optionTitle }}
                </div>
                <router-link id="goto" v-else-if="added == true" :to="{ name: 'cart' }">Show Cart</router-link>
                <div id="add" v-else @click="addToCart">Add to Cart</div>
                <div class="text" v-html="product.description"></div>
                <div id="infoContainer">
                    <p class="infos" v-for="info in product.infos">
                        {{ info }}
                    </p>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import Footer from "./Footer.vue";

export default {
    name: "ShopDetail",
    components: {
        Footer,
    },
    data() {
        return {
            product: {
                pk: 0,
                images: [],
                title: "",
            },
            selected: "",
            store: store,
            added: false,
        };
    },

    methods: {
        formatPrice(price) {
            return "$" + price.toFixed(2);
        },
        addToCart() {
            if (
                this.store.cart.items.find(
                    (i) => this.product.pk == i.pk && this.selected == i.option
                )
            ) {
                let item = this.store.cart.items.find(
                    (i) => this.product.pk == i.pk && this.selected == i.option
                );
                item.amount += 1;
            } else {
                this.store.cart.items.push({
                    pk: this.product.pk,
                    title: this.product.title,
                    price: this.product.price,
                    option: this.selected,
                    amount: 1,
                });
            }
            this.added = true
        },
    },
    mounted: function () {
        axios.get("/api/shop/" + this.$route.params.id).then((response) => {
            this.product = response.data;
        });

        window.scrollTo(0, 0);
    },
    activated: function () {
        this.added = false
    }
};
</script>

<style scoped>
#detail {
    margin: 1rem;
    max-width: 100%;
}

@media only screen and (min-width: 1101px) {
    #detail {
        max-width: 66%;
    }
}

@media only screen and (min-width: 1440px) {
    #detail {
        max-width: 50%;
    }
}

@media only screen and (min-width: 1900px) {
    #detail {
        max-width: 33%;
    }
}

.mainImage {
    width: 100%;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    /* min-width: calc(100vw - 2rem); */
    /* min-height: calc(100vw - 2rem); */
    background-color: #d2d2d2;
    cursor: pointer;
    margin-bottom: -5px;
}

.mainImage.LI {
    background-color: #8dd9fc;
}

.mainImage.IS {
    background-color: #f6b2c6;
}

.mainImage.IR {
    background-color: #f6b2c6;
}

.mainImage.RE {
    background-color: #9fe1a7;
}

.mainImage.NY {
    background-color: #fcfac4;
}

/* @media only screen and (min-width: 1101px) { */
/*     #mainImage { */
/*         min-width: calc(66vw - 2rem); */
/*         max-width: calc(66vw - 2rem); */
/*         min-height: calc(66vw - 2rem); */
/*     } */
/* } */
/* @media only screen and (min-width: 1440px) { */
/*     #mainImage { */
/*         min-width: calc(50vw - 2rem); */
/*         max-width: calc(50vw - 2rem); */
/*         min-height: calc(50vw - 2rem); */
/*     } */
/* } */
/* @media only screen and (min-width: 1900px) { */
/*     #mainImage { */
/*         min-width: calc(33vw - 2rem); */
/*         max-width: calc(33vw - 2rem); */
/*         min-height: calc(33vw - 2rem); */
/*     } */
/* } */
.buttonImage,
.buttonSpacer {
    width: 1.8rem;
    min-width: unset;
    min-height: unset;
    background-color: transparent;
}

.buttonText {
    flex-grow: 1;
}

#location span:first-child {
    margin-right: 1rem;
}

#location {
    margin-bottom: 0.7rem;
}

#time {
    margin-bottom: 1.4rem;
}

#date {
    margin-top: 0.3rem;
}

#date,
#time {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
}

.text {
    margin-bottom: 1rem;
}

.text>>>a {
    color: #aaaaaa;
}

#links .text {
    margin-bottom: 0;
}

#links a {
    color: #aaaaaa;
}

#links a:hover {
    color: black;
}

#audio {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 0.7rem;
}

@media only screen and (min-width: 738px) {
    #audio {
        flex-direction: row;
    }
}

#audio>div {
    border: 1px solid black;
    text-align: center;
    padding: 0.65rem 1rem 0.85rem;
    margin-bottom: 1rem;
}

#audio>div:last-of-type {
    margin-bottom: 0;
}

#audio>div:hover {
    background-color: black;
    color: white;
}

@media only screen and (min-width: 738px) {
    #audio>div {
        width: 50%;
        margin-left: 0.5rem;
        margin-bottom: 0;
    }

    #audio>div:first-child {
        margin-left: 0;
        margin-right: 1rem;
    }
}

#infoContainer {
    margin-top: 0.6rem;
    margin-bottom: 1.6rem;
}

.infos {
    display: flex;
    gap: 1rem;
    align-items: center;
    width: calc(100vw - 2rem);
    margin: 0;
}

img#play {
    cursor: pointer;
    height: 3rem;
    width: 3rem;
    background-color: transparent;
    min-height: unset;
    min-width: unset;
    max-height: unset;
    max-width: unset;
}

.playlistItem {
    padding: 0.5rem 1rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    white-space: nowrap;
    color: grey;
    font-size: 12px;
    font-family: "Montez Small";
    line-height: initial;
}

.playlistItem:last-child {
    padding-bottom: 2rem;
}

.playlistItem.desktop:last-child {
    border-bottom: 1px solid lightgrey;
}

.playlistItem.desktop {
    font-size: initial;
    font-family: "Montez Large";
    padding: 1rem;
    border-top: 1px solid lightgrey;
}

.playlistItem>.title {
    flex-grow: 1;
}

.playlistItem>img {
    flex-shrink: 0;
    object-fit: cover;
    height: 51px;
    width: 51px;
}

.playlistItem.desktop>img {
    height: 26px;
    width: 26px;
}

.playlistItem.activeItem {
    color: black;
    border-top: none;
}

.playlistItem.activeItem>img {
    height: 51px;
    width: 51px;
}

.playlistDate {
    font-variant-numeric: tabular-nums;
    font-feature-settings: "case" on;
}

#playlist {
    width: 100%;
}

#price {
    margin-bottom: 2rem;
}

#options {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
    cursor: pointer;
}

.option {
    padding: 0.8rem 1rem;
    border: 1px solid black;
}

.option:hover {
    color: white;
    background-color: black;
}

.option.selected {
    color: white;
    background-color: black;
}

#select {
    color: lightgrey;
    border: 1px solid lightgrey;
}

#select,
#add,
#goto {
    text-align: center;
    margin: 1rem 0 2rem;
    padding: 0.8rem;
    box-sizing: border-box;
    width: 100%;
    display: block;
}

@media only screen and (min-width: 738px) {

    #select,
    #add,
    #goto {
        width: 50%;
    }
}

#add,
#goto {
    border: 1px solid black;
    cursor: pointer;
}

#add:hover,
#goto:hover {
    color: white;
    background-color: black;
}

#textContainer {
    margin-top: 1.3rem;
}

#galleryContainer {
    position: relative;
}

#paginationContainer {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 1;
}

#pagination {
    display: flex;
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on;
    border-radius: 12px;
    background-color: white;
    padding: 1px 8px 3px;
}

#swiperContainer {
    border-radius: 12px;
    overflow: hidden;
}


.miscContent {
    padding-top: 1rem;
}
</style>
